import React from 'react';
import { PiLaptopLight, PiListChecks } from 'react-icons/pi';
import AnimateIn from './AnimateIn';
import PhpSecurityAdvisory from './PhpSecurityAdvisory';

const Contact = () => (
  <section id="services" className="overflow-hidden bg-[#f1efff] px-6 py-16 text-ink md:px-12 lg:px-16 lg:py-20">
    <div className="mx-auto max-w-[90rem]">
      <AnimateIn variant="fade-up" className="max-w-[720px]">
        <p className="text-sm font-bold uppercase tracking-[0.16em] text-violet-dark">Our services</p>
        <div className="mt-4 h-1 w-16 bg-violet" />
        <h2 className="mt-8 text-5xl font-semibold leading-[0.94] tracking-[-0.055em] md:text-6xl">Need a clear,<br />dependable website?</h2>
        <p className="mt-6 max-w-[640px] text-base leading-7 text-ink/70">
          Alongside the products we build, we help UK small businesses with practical website work — from a new site to a clear view of how an existing one is doing.
        </p>
      </AnimateIn>

      <AnimateIn variant="fade-up" delay={60} className="mt-12">
        <article className="overflow-hidden rounded-[1.75rem] bg-white shadow-[0_18px_60px_rgba(4,11,65,.07)]">
          <div className="grid items-stretch lg:grid-cols-[0.92fr_1.08fr]">
            <div className="flex flex-col justify-center p-7 sm:p-10 lg:p-12">
              <p className="text-sm font-bold uppercase tracking-[0.16em] text-violet-dark">Recent website work</p>
              <div className="mt-4 h-1 w-16 bg-violet" />
              <h3 className="mt-7 text-3xl font-semibold tracking-[-0.04em] md:text-4xl">Faithful Living</h3>
              <p className="mt-3 text-sm font-medium text-ink/55">Website redesign for a Southfields wellbeing practice</p>
              <p className="mt-5 max-w-[34rem] text-base leading-7 text-ink/70">
                We helped Irina rebuild faithful-living.com so visitors can understand the sessions on offer, read client feedback, find the clinic and book with confidence — on phone and desktop.
              </p>
              <ul className="mt-6 space-y-2 text-sm leading-6 text-ink/65">
                <li>Clearer path from first visit to booking</li>
                <li>Mobile-friendly layout for busy local clients</li>
                <li>Practical pages for sessions, reviews, location and contact</li>
              </ul>
              <a
                href="https://faithful-living.com/"
                target="_blank"
                rel="noreferrer"
                className="btn-navy mt-8 self-start"
              >
                Visit the website <span aria-hidden="true">→</span>
              </a>
            </div>
            <a
              href="https://faithful-living.com/"
              target="_blank"
              rel="noreferrer"
              className="relative block min-h-[280px] overflow-hidden bg-[#1f3329] lg:min-h-full"
              aria-label="Open the Faithful Living website"
            >
              <img
                src={`${process.env.PUBLIC_URL}/work/faithful-living-website.jpg`}
                alt="Screenshot of the Faithful Living website homepage"
                className="h-full min-h-[280px] w-full object-cover object-[center_top] lg:min-h-[420px]"
                loading="lazy"
              />
            </a>
          </div>
        </article>
      </AnimateIn>

      <div className="mt-8 grid gap-6 lg:grid-cols-2">
        <AnimateIn variant="fade-up" className="flex flex-col rounded-[1.5rem] bg-white p-7 shadow-[0_18px_60px_rgba(4,11,65,.07)] sm:p-9">
          <div className="principle-icon" data-tone="violet"><PiLaptopLight aria-hidden="true" /></div>
          <h3 className="mt-5 text-2xl font-semibold tracking-[-0.03em]">Website Design &amp; Development</h3>
          <p className="mt-3 flex-1 text-base leading-7 text-ink/70">
            Thoughtful, mobile-friendly websites built around what your business and customers actually need.
          </p>
          <p className="mt-5 font-hand text-2xl leading-tight text-[#17305c]">Good ideas deserve a home online.</p>
          <a href="/contact?type=website" className="btn-navy mt-8 self-start">Let’s work together <span aria-hidden="true">→</span></a>
        </AnimateIn>

        <AnimateIn variant="fade-up" delay={80} className="flex flex-col rounded-[1.5rem] bg-white p-7 shadow-[0_18px_60px_rgba(4,11,65,.07)] sm:p-9">
          <div className="principle-icon" data-tone="green"><PiListChecks aria-hidden="true" /></div>
          <h3 className="mt-5 text-2xl font-semibold tracking-[-0.03em]">Website Health &amp; Security Check</h3>
          <p className="mt-3 text-base leading-7 text-ink/70">
            Understand whether your website is up to date, working properly and giving customers a reliable experience.
          </p>
          <ul className="mt-5 space-y-2 text-sm leading-6 text-ink/70">
            <li>£79 one-off introductory price</li>
            <li>No subscription required</li>
            <li>Clear report with practical recommendations</li>
          </ul>
          <a href="/website-health-check" className="btn-navy mt-8 self-start">View the health check <span aria-hidden="true">→</span></a>
        </AnimateIn>
      </div>

      <AnimateIn variant="fade-up" delay={120} className="mt-8">
        <PhpSecurityAdvisory headingLevel="h3" compact />
      </AnimateIn>
    </div>
  </section>
);

export default Contact;
